import { useEffect } from 'react';
import { Platform } from 'react-native';
import { useTheme } from './useTheme';

/**
 * Mirrors theme tokens that global web CSS needs (app/+html.tsx) into CSS
 * custom properties on <html>. Currently just the keyboard focus-ring color.
 * No-op on native.
 */
export function useSyncWebThemeVars() {
  const { colors } = useTheme();

  useEffect(() => {
    if (Platform.OS !== 'web' || typeof document === 'undefined') return;
    document.documentElement.style.setProperty('--redi-focus-ring', colors.borderFocus);
  }, [colors.borderFocus]);
}
